import React, {Component} from 'react'
import PropTypes from 'prop-types'

function validateEmail(email) 
{
	var re = /\S+@\S+\.\S+/
	return re.test(email)
}

export default class EmailInput extends Component {
	constructor(props) {
		super(props)
		this.ref = React.createRef()
		this.handleChange = this.handleChange.bind(this)
		this.state = {
			email: props.email || ''
		}
		if(validateEmail(props.email)) { props.validEmailEntered(props.email) }
	}

	componentDidMount() {
		if(this.props.focus) {
			this.ref.current.focus()
		}
	}

	handleChange(event) {
		const email = event.target.value
		this.setState({email})
		if(validateEmail(email)) {
			this.props.validEmailEntered(email)
		} else {
			this.props.invalidEmailEntered(email)
		}
	}

	render() {
		return (
			<input
				type="email"
				ref={this.ref}
				placeholder='Enter your work email address'
				value={this.state.email}
				onChange={this.handleChange}
				disabled={this.props.disabled} />
		)
	}
}

EmailInput.propTypes = {
	focus: PropTypes.bool,
	disabled: PropTypes.bool,
	validEmailEntered: PropTypes.func,
	invalidEmailEntered: PropTypes.func,
	email: PropTypes.string
}

export { EmailInput } 


// WEBPACK FOOTER //
// ./src/containers/AdMonitorHome/EmailInput.js